import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'

const trimestersBuybacksFields: FieldInterface[] = [
  {
    key: 'ageOfRetirement',
    originKey: 'age_of_retirement',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'nbTrimTotalRachat',
    originKey: 'nbTrimTotalRachat',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'coutRachat',
    originKey: 'coutRachat',
    type: FIELD_TYPES.number,
  },
  {
    key: 'coutRachatRevalorise',
    originKey: 'coutRachatRevalorise',
    type: FIELD_TYPES.number,
  },
  {
    key: 'delay',
    originKey: 'delai',
    type: FIELD_TYPES.number,
  },
  {
    key: 'nbTrim',
    originKey: 'nbTrim',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'nbTrimAcquis',
    originKey: 'nbTrimAcquis',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'nbTrimMax',
    originKey: 'nbTrimMax',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'retraiteBase',
    originKey: 'retraiteBase',
    type: FIELD_TYPES.number,
  },
  {
    key: 'retraiteComp',
    originKey: 'retraiteComp',
    type: FIELD_TYPES.number,
  },
  {
    key: 'retraiteTotale',
    originKey: 'retraiteTotale',
    type: FIELD_TYPES.number,
  },
  {
    key: 'retraiteTotaleRachat',
    originKey: 'retraiteTotaleRachat',
    type: FIELD_TYPES.number,
  },
  {
    key: 'supplement',
    originKey: 'supplement',
    type: FIELD_TYPES.number,
  },
  {
    key: 'tauxActualisation',
    originKey: 'tauxActualisation',
    type: FIELD_TYPES.number,
  },
  {
    key: 'rachatId',
    originKey: 'rachatId',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'coutTotalRachat',
    originKey: 'coutTotalRachat',
    type: FIELD_TYPES.number,
  },
]

const trimestersBuybacksRelations: RelationInterface[] = []

export { trimestersBuybacksFields, trimestersBuybacksRelations }
